import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	panelHeading: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.panel-heading',
		defaultMessage: 'Templates',
		description: 'Title for the intent templates side panel',
	},
	panelDescription: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.panel-description',
		defaultMessage:
			'Select a pre-made template from our catalog, or a template automatically generated using your data.',
		description: 'Description for the intent templates side panel',
	},
	infoIconLabel: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.info-icon-label',
		defaultMessage: 'More information about intent templates',
		description:
			'Label text used for an information icon (the letter i in a circle) that a user can hover over to view more information about intent templates',
	},
	loadMoreTemplatesButton: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.load-more-templates-button',
		defaultMessage: 'Load more templates',
		description:
			'Text on a button that when clicked will load more intent templates in the sidebar',
	},
	errorFlagTitle: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-title',
		defaultMessage: "We couldn't load intent templates",
		description: 'Title in error flag displayed when intent templates fail to load',
	},
	errorFlagTitleQuestions: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-title-questions',
		defaultMessage: 'We couldn’t generate training phrases for this template',
		description:
			'Title in the error flag that will show when questions cannot be fetched for intent template',
	},
	errorFlagDescriptionQuestions: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-description-questions',
		defaultMessage:
			'Enter training phrases manually, or try using this template later. Intent templates are refreshed every week.',
		description: 'Description in error flag displayed when intent templates fail to load',
	},
	errorFlagDescription: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-description',
		defaultMessage: 'Wait a moment and then try again.',
		description: 'Description in error flag displayed when intent templates fail to load',
	},
	closeIconLabel: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.close-icon-label',
		defaultMessage: 'Close intent templates sidebar',
		description:
			'Label text used for a close icon that a user can click to close the right sidebar',
	},
	activateAiSectionMessageTitle: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.activate-ai-section-message-title',
		defaultMessage: 'Activate Atlassian Intelligence to use custom templates',
		description: 'Section message title displayed when atlassian intelligence is not turned on',
	},
	activateAiSectionMessageDescription: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.activate-ai-section-message-description',
		defaultMessage:
			'To use templates generated using your project’s data, your organization admin needs to <link>activate Atlassian Intelligence</link>.',
		description:
			'Section message description displayed when atlassian intelligence is not turned on',
	},
	loadingTemplatesSectionMessageTitle: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.loading-templates-section-message-title',
		defaultMessage: 'We’re loading your custom templates',
		description: 'Section message title displayed when atlassian intelligence is not turned on',
	},
	loadingTemplatesSectionMessageDescriptionOne: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.loading-templates-section-message-description-one',
		defaultMessage: 'When they’re ready, you’ll see <b>Your data</b> templates below.',
		description:
			'First section message description displayed when atlassian intelligence is turned on but templates have not been loaded yet or there was some other error',
	},
	loadingTemplatesSectionMessageDescriptionTwo: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.loading-templates-section-message-description-two',
		defaultMessage:
			'If this message persists for more than 24 hours, you may not have enough data to generate templates (or there may be a technical problem). For help, <link>contact Support</link>.',
		description:
			'Second section message description displayed when atlassian intelligence is turned on but templates have not been loaded yet or there was some other error',
	},
});
